import React, { createContext, useContext, useReducer } from 'react';
import reducer from './reducer';

export const initialState = {
  eventState: '',
  events: [],
  noMoreEvent: false,
  eventFilters: {},
  eventNotifications: [],
  readEventNotifications: [],
}

export const EventStateContext = createContext();
export const EventDispatchContext = createContext();

function EventContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <EventStateContext.Provider value={state}>
      <EventDispatchContext.Provider value={dispatch}>
        {children}
      </EventDispatchContext.Provider>
    </EventStateContext.Provider>
  )
}

function useEventDispatch() {
  const context = useContext(EventDispatchContext)
  if (context === undefined) {
    throw new Error('useEventDispatch must be used within a EventProvider')
  }
  return context
}

function useEventState() {
  const context = useContext(EventStateContext)
  if (context === undefined) {
    throw new Error('useEventState must be used within a EventProvider')
  }
  return context
}

export { EventContext, useEventDispatch, useEventState };